import React from 'react';
import { STATUS } from '../state/model';

// Section verify header: "אומתו X מתוך Y" + approve-all (the quiet verify flow
// from the redesign — one click clears a section's pending extractions).
export default function VerifyTools({ obj, keys, onApproveAll }) {
  const st = (k) => obj?.[k]?.status;
  const approved = keys.filter((k) => st(k) === STATUS.APPROVED).length;
  const pending = keys.filter((k) => st(k) === STATUS.AUTO || st(k) === STATUS.ESTIMATED).length;
  const total = approved + pending;
  if (total === 0) return null;
  return (
    <div className="rd-verify-tools">
      <span className="rd-verify-counter">אומתו {approved} מתוך {total}</span>
      {pending > 0 && onApproveAll && (
        <button type="button" className="rd-approve-all" onClick={onApproveAll}>אשר את כל החילוצים</button>
      )}
    </div>
  );
}
